import React from 'react'
import { Button, Spin, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { ModalWarningIcon } from 'src/assets/icons'

import './index.scss'
import { LoadingOutlined } from '@ant-design/icons'
import RichTextField from 'src/app/shared/components/common/rich-text-field'

interface Props {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    accountNames: string[]
    isLoading?: boolean
}

function ServiceTypeParameterValidationModal(props: Props) {
    const { isOpen, onClose, onConfirm, accountNames, isLoading = false } = props
    const { t } = useTranslation()

    return (
        <ActionConfirmationModal
            icon={<ModalWarningIcon />}
            title={<Typography className='modal-title'>{t('ClientSetup:addNewClient.modal.serviceTypeParameterValidation.title')}</Typography>}
            onClose={onClose}
            isOpen={isOpen}
            descriptionType='string'
            description={
                <Typography className='modal-description'>
                    <RichTextField richText={t('ClientSetup:addNewClient.modal.serviceTypeParameterValidation.description')} />
                    <ul
                        style={{
                            paddingTop: '2rem',
                            textAlign: 'left',
                            listStylePosition: 'inside',
                            paddingLeft: 0,
                            marginLeft: 0,
                            maxHeight: '240px',
                            overflowY: 'auto',
                        }}
                    >
                        {accountNames.map(name => (
                            <li key={name}>{name}</li>
                        ))}
                    </ul>
                </Typography>
            }
            footer={[
                <Button size='middle' type='primary' onClick={onConfirm}>
                    {isLoading ? (
                        <Spin
                            indicator={
                                <LoadingOutlined
                                    style={{
                                        color: 'white',
                                    }}
                                />
                            }
                        />
                    ) : (
                        t('common:close')
                    )}
                </Button>,
            ]}
        />
    )
}

export default ServiceTypeParameterValidationModal
